import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FRONTEND_ROUTES } from "@fysaro/shared";
import { Button } from "@/design-system/components/ui/button";

const STORAGE_KEY = "fysaro:cookie-notice-ack";

/**
 * Informational notice for the public marketing site.
 * Fysaro does not load third-party analytics cookies yet; this documents that
 * fact and links to the cookie policy. Extend here when GA/Tag Manager is added.
 */
export function CookieNotice() {
  const { t } = useTranslation(["landing"]);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (localStorage.getItem(STORAGE_KEY) === "1") return;
      setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  const dismiss = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "1");
    } catch {
      // Ignore storage failures; hide for this session anyway.
    }
    setVisible(false);
  };

  return (
    <div
      role="dialog"
      aria-live="polite"
      className="fixed bottom-0 inset-x-0 z-[100] border-t border-border bg-background/95 backdrop-blur p-4 shadow-lg"
    >
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6">
        <p className="text-sm text-muted-foreground flex-1 leading-relaxed">
          {t("landing:cookie_notice.message")}{" "}
          <Link
            to={FRONTEND_ROUTES.public.legalCookies}
            className="text-primary font-medium hover:underline"
          >
            {t("landing:cookie_notice.policy_link")}
          </Link>
        </p>
        <Button type="button" size="sm" onClick={dismiss} className="shrink-0">
          {t("landing:cookie_notice.accept")}
        </Button>
      </div>
    </div>
  );
}
